import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Grid, Radio, Typography, useTheme} from "@mui/material";
import { ExpandMore} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import {IRaDetailView} from "../../models/models";
import {FormCheckbox, FormDateTimePicker, FormRadioGroup, FormTextField} from "../../common/form-fields-wrappers";

const ExtensionInfo = ({numExtension}: {numExtension: number}) => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const raDetailForm = useFormContext<IRaDetailView>();

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.extension.accordion.title")} {"N"}{numExtension + 1}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormRadioGroup<IRaDetailView>
                            name={`extensionInfo.${numExtension}.renewedByExtension`}
                            label={t("raDetail.extension.form.label.renewedByExtension")}
                            control={raDetailForm.control}
                            disabled
                        >
                            <FormControlLabel
                                value="false"
                                label={t("raDetail.extension.form.label.no")}
                                control={<Radio />}
                            />
                            <FormControlLabel
                                value="true"
                                label={t("raDetail.extension.form.label.yes")}
                                control={<Radio />}
                            />
                        </FormRadioGroup>
                    </Grid>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IRaDetailView>
                            name={`extensionInfo.${numExtension}.reqExtensionDropoffDateTime`}
                            control={raDetailForm.control}
                            label={t("raDetail.extension.form.label.reqExtensionDropoffDateTime")}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.extensionPeriod`}
                            control={raDetailForm.control}
                            label={t("raDetail.extension.form.label.extensionPeriod")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.billingOwner`}
                            control={raDetailForm.control}
                            label={t("raDetail.extension.form.label.billingOwner")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormCheckbox<IRaDetailView>
                            name={`extensionInfo.${numExtension}.reservedPricing`}
                            label={t("extensionManagement.recapInfo.form.label.reservedPricing")}
                            color={'primary'}
                            disabled
                            sx={{color: theme.palette.primary.main}}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.rentalExtensionAmount`}
                            control={raDetailForm.control}
                            label={t("extensionManagement.recapInfo.form.label.rentalExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.ancillariesExtensionAmount`}
                            control={raDetailForm.control}
                            label={t("extensionManagement.recapInfo.form.label.ancillariesExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.totalExtensionAmount`}
                            control={raDetailForm.control}
                            label={t("extensionManagement.recapInfo.form.label.totalExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name={`extensionInfo.${numExtension}.lastModifiedBy`}
                            control={raDetailForm.control}
                            label={t("raDetail.extension.form.label.lastModifiedBy")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IRaDetailView>
                            name={`extensionInfo.${numExtension}.extendedTimestamp`}
                            control={raDetailForm.control}
                            label={t("raDetail.extension.form.label.extensionTimestamp")}
                            disabled
                        />
                    </Grid>

                    {/*<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>*/}
                    {/*    <FormDateTimePicker<IRaDetailView>*/}
                    {/*        name={`extensionInfo.${numExtension}.extendedDropoffDateTimeAllowed`}*/}
                    {/*        control={raDetailForm.control}*/}
                    {/*        label={t("raDetail.extension.form.label.extendedDropoffDateTimeAllowed")}*/}
                    {/*        disabled*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default ExtensionInfo;